import type { Class } from "type-fest";
import { componentsScope } from "../utils/logger";

export const extendScope = componentsScope.scope("extend-custom-element");

interface CustomElementInstance extends HTMLElement {
  /**
 *
 *
 */
  connectedCallback(): Promise<void> | void;
  /**
 *
 *
 */
  disconnectedCallback(): Promise<void> | void;
  /**
 *
 */
  adoptedCallback(): void;
  /**
 *
 *
 *
 *
 */
  attributeChangedCallback(name: string, oldValue: string, newValue: string): void;
  /**
 *
 */
  resetForm?(): void;

  /**
 *
 */
  $$shadowRoot?: ShadowRoot;

  /**
 *
 */
  __shadow?: boolean;
}

/**
 *
 *
 */
export type CustomElement<Extends = void> = (void extends Extends
  ? Class<CustomElementInstance>
  : Class<CustomElementInstance & Extends>) & {
  /**
 *
 */
  readonly observedAttributes: string[];
};
